import { sleep } from '@ipfabric/ui-components/utils/sleep';
import type { NodeSn } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { highlightGraphNode } from '../pathLookup/highlightGraphNode';
import { unhighlightGraphNode } from '../pathLookup/unhighlightGraphNode';

interface AnimateNodeCommand {
  currentNodeSn: NodeSn;
  followingNodeSn?: NodeSn;
}

export const animateNode: GraphCommandFactory<AnimateNodeCommand> =
  (_cmdContext, dispatch) => async (command) => {
    if (command.followingNodeSn === undefined) {
      return;
    }
    // Wait for path inspector command to finish not to get unhighlighted following node
    await sleep(0);

    dispatch(unhighlightGraphNode, { nodeSn: command.currentNodeSn });
    dispatch(highlightGraphNode, { nodeSn: command.followingNodeSn });
    await sleep(1000);
    dispatch(unhighlightGraphNode, { nodeSn: command.followingNodeSn });
  };
